import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import "./index.less";

const TabList = ({ id, children, value, className, variant }) => {
    const tabRef = useRef();

    const classByVariant = () => {
        switch (variant) {
            case 'horizontal-pill':
                return 'tab-list-horizontal-pill';
            case 'horizontal-label':
                return 'tab-list-horizontal-label';
            default:
                return 'tab-list-horizontal-label';
        }
    }

    useEffect(() => {
        if (!tabRef.current) return;
        const activeEl = tabRef.current.querySelector(`[data-tab-item-id="${value}"]`);
        if (activeEl) {
            tabRef.current.scrollTo({ left: activeEl.offsetLeft - (activeEl.offsetWidth / 2), behavior: "smooth" });
        }
    }, [value]);

    return (
        <div id={id} ref={tabRef} className={classNames("tab-list", className, classByVariant())} role="tablist">{children}</div>
    );
};

TabList.Item = ({ children, id, onClick, active, count }) => {
    const onClickHandler = () => {
        if (typeof onClick === "function") {
            onClick();
        }
    };

    const attributes = {};
    if (count > 0) {
        attributes['data-count'] = count;
    }
    return (
        <a
            role="tab"
            aria-selected={active}
            data-tab-item-id={id}
            aria-label={typeof children === 'string' ? children : undefined}
            onClick={onClickHandler}
            className={classNames("tab-list-item", { active })}
            {...attributes}
        >
            {children}
        </a>
    );
};

export default TabList;
